import type { ReactNode } from 'react'

import { Footer } from './Footer'

interface FullPageLayoutProps {
  children: ReactNode
}

export function FullPageLayout({ children }: FullPageLayoutProps) {
  return (
    <div className="flex flex-col min-h-screen">
      <div className="flex-grow bg-white">
        <div className="max-w-screen-md mx-auto sm:py-8 px-4 sm:px-6 md:px-10 2xl:px-0">
          {children}
        </div>
      </div>
      <Footer centered={false} className="z-10 lg:sticky bottom-0" maxScreen="max-w-screen-md" />
    </div>
  )
}

export default FullPageLayout
